import {z} from 'zod';

const GetSkillCheckLastResultSchema = z.object({
  userScore: z.number(),
  maxScore: z.number(),
  topPercentage: z.number(),
  testDateTime: z.string(),
  historyUUID: z.string(),
});
export type GetSkillCheckLastResultType = z.infer<
  typeof GetSkillCheckLastResultSchema
>;

const GetSkillCheckCategorySchema = z.object({
  id: z.number(),
  name: z.string(),
  genre: z.string(),
  displayOrder: z.number(),
  lastResult: GetSkillCheckLastResultSchema.optional(),
});

export const GetSkillCheckTopSchema = z.object({
  categories: z.array(GetSkillCheckCategorySchema),
});

const GetSkillCheckQuestionSchema = z.object({
  id: z.number(),
  question: z.string(),
  choices: z.array(
    z.object({
      id: z.number(),
      name: z.string(),
    }),
  ),
});

export const GetSkillCheckQuestionsSchema = z.object({
  name: z.string(),
  genre: z.string(),
  questions: z.array(GetSkillCheckQuestionSchema),
});

export type GetSkillCheckQuestionType = z.infer<
  typeof GetSkillCheckQuestionSchema
>;

const SkillCheckQuestionAnswerSchema = z.object({
  questionId: z.number(),
  choiceId: z.number(),
});

export type SkillCheckQuestionAnswerType = z.infer<
  typeof SkillCheckQuestionAnswerSchema
>;

export const PostSkillCheckAnswersResponseSchema = z.object({
  historyUUID: z.string(),
});
export type PostSkillCheckAnswersResponse = z.infer<
  typeof PostSkillCheckAnswersResponseSchema
>;

const GetSkillCheckResultQuestionSchema = z.object({
  question: z.string(),
  explanation: z.string(),
  correctChoice: z.object({
    id: z.number(),
    name: z.string(),
  }),
  userChoice: z.object({
    id: z.number(),
    name: z.string(),
  }),
});

export type GetSkillCheckResultQuestionType = z.infer<
  typeof GetSkillCheckResultQuestionSchema
>;

export const GetSkillCheckResultSchema = z.object({
  categoryName: z.string(),
  userScore: z.number(),
  totalScore: z.number(),
  topPercentage: z.number(),
  questions: z.array(GetSkillCheckResultQuestionSchema),
  histories: z.array(
    z.object({
      userScore: z.number(),
      testDateTime: z.string(),
    }),
  ),
});
